import { IRequestWrap } from '../../../server/IServer';
import { EN_APP_DEVICE } from './EN_APP_DEVICE';

export const getDevice = (req: IRequestWrap): EN_APP_DEVICE | null => {
  const deviceName = (req.ua.getOS()?.name || '').toLowerCase();

  return deviceName === EN_APP_DEVICE.ANDROID || deviceName === EN_APP_DEVICE.IOS ? deviceName : null;
};
